/* istanbul ignore file */
import { boolean as codecBoolean, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PatchUserDataParser = /* #__PURE__ */ parsers.object([
    ['email', /* #__PURE__ */ codecOptional(codecString)],
    ['oldPassword', /* #__PURE__ */ codecOptional(codecString), 'old_password'],
    ['name', /* #__PURE__ */ codecOptional(codecString)],
    ['newPassword', /* #__PURE__ */ codecOptional(codecString), 'new_password'],
    ['resetEmailOnLti', /* #__PURE__ */ codecOptional(codecBoolean), 'reset_email_on_lti'],
]);
export class PatchUserData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchUserDataParser.decode(input).map(res => new PatchUserData(res));
    }
    static unsafeDecode(input) {
        return PatchUserData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchUserDataParser.encode(data);
    }
    static schema() {
        return PatchUserDataParser.schema();
    }
}
